<template>
    <div>
        <b-button variant="outline-light" v-on:click="getDetay()" size="sm">
            <Icon icon="ep:select" width="25" height="25" v-b-tooltip.hover.bottom="'Şeç'"
                color="#28C76F" />
        </b-button>
    </div>
</template>
<script>
import { Icon } from "@iconify/vue2";
export default {
    components: {
        Icon
    },
    methods: {
        getDetay() {
            this.$root.$emit("getStokSecMarketplace", this.params.data);
        }
    }
};
</script>
  